import { EMPTY_COLUMN_PREFERENCE, parseColumnPreference, type ColumnPreference } from '@immo/components';
import { apiClient } from '@/lib/auth/api-client';

// One key per operator list. Kept here, not in the contract: this app is the store's only caller.
export const OPERATOR_COLUMN_KEYS = {
  workspaces: 'workspace-columns',
  members: 'member-columns',
  organizations: 'organization-columns',
  admins: 'admin-columns',
  documentAnalyses: 'document-analysis-columns',
  agentSkills: 'agent-skill-columns',
  factKeys: 'fact-key-columns',
  properties: 'property-columns',
  apiKeys: 'api-key-columns',
  deletedDeals: 'deleted-deal-columns',
  deletedCompanies: 'deleted-company-columns',
  mcpAccess: 'mcp-access-columns',
  valuationRequests: 'valuation-request-columns',
  messengerChats: 'messenger-chat-columns',
  apiCalls: 'api-call-columns',
  apiKeyRequests: 'api-key-request-columns',
} as const;
export type OperatorColumnKey = (typeof OPERATOR_COLUMN_KEYS)[keyof typeof OPERATOR_COLUMN_KEYS];

// Runs beside the list fetch, never in front of it. A failed read is the default
// order — the table must always render.
export async function loadOperatorColumnPreference(key: OperatorColumnKey): Promise<ColumnPreference> {
  try {
    const result = await apiClient.adminPreferences.getMine({ pathParams: { key } });

    return result.ok ? parseColumnPreference(result.body.value) : EMPTY_COLUMN_PREFERENCE;
  } catch {
    return EMPTY_COLUMN_PREFERENCE;
  }
}
